import { get, orderBy } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { NO_DATA_MESSAGE } from '../../utils/constants'
import ScrollingTable, { dateRenderer } from '../Tables/ScrollingTable'

class DistributionHistory extends Component {
  constructor(props) {
    super(props)

    const distributions = get(props.data, 'distributions', [])
    this.state = {
      distributions:
        distributions.length > 0
          ? orderBy(distributions, ['payableDateCalendar.date'], ['desc'])
          : null,
    }

    this.distributionRenderer = this.distributionRenderer.bind(this)
    this.priceRenderer = this.priceRenderer.bind(this)

    this.columns = [
      {
        Header: 'Record Date',
        id: 'recordDate',
        accessor: (a) => a.recordDateCalendar?.date || '',
        Cell: dateRenderer,
      },
      {
        Header: 'Reinvest Date',
        id: 'reinvestDate',
        accessor: (a) => a.reinvestDateCalendar?.date || '',
        Cell: dateRenderer,
      },
      {
        Header: 'Payable Date',
        id: 'payableDate',
        accessor: (a) => a.payableDateCalendar?.date || '',
        Cell: dateRenderer,
      },
      {
        Header: 'Return of Capital Non Taxable Dist',
        id: 'nonTaxableDiscount',
        accessor: 'nonTaxableDiscount',
        Cell: this.distributionRenderer,
      },
      {
        Header: 'Ordinary Income',
        id: 'ordinaryIncome',
        accessor: 'ordinaryIncome',
        Cell: this.distributionRenderer,
      },
      {
        Header: 'Total Capital Gains',
        id: 'totalCapitalGains',
        accessor: (d) =>
          d.shortTermCapitalGains +
          d.midTermCapitalGains +
          d.longTermCapitalGains,
        Cell: this.distributionRenderer,
      },
      {
        Header: 'Short Term Capital Gains',
        id: 'shortTermCapitalGains',
        accessor: 'shortTermCapitalGains',
        Cell: this.distributionRenderer,
      },
      {
        Header: 'Mid Term Capital Gains',
        id: 'midTermCapitalGains',
        accessor: 'midTermCapitalGains',
        Cell: this.distributionRenderer,
      },
      {
        Header: 'Long Term Capital Gains',
        id: 'longTermCapitalGains',
        accessor: 'longTermCapitalGains',
        Cell: this.distributionRenderer,
      },
      {
        Header: 'Total Distribution',
        id: 'totalDividend',
        accessor: 'totalDividend',
        Cell: this.distributionRenderer,
      },
      {
        Header: 'Foreign Tax Credit',
        id: 'foreignTaxCredit',
        accessor: 'foreignTaxCredit',
        Cell: this.distributionRenderer,
      },
      {
        Header: 'Reinvest Price',
        id: 'reinvestmentPrice',
        accessor: 'reinvestmentPrice',
        Cell: this.priceRenderer,
      },
    ]

    this.scrollingTableOptions = {
      presentation: props.presentation,
      stripedTable: true,
    }
  }

  distributionRenderer(props) {
    const value = props.value
    return <span>{!isNaN(value) ? parseFloat(value).toFixed(5) : '--'}</span>
  }

  priceRenderer(props) {
    const value = props.value
    return <span>{!isNaN(value) ? parseFloat(value).toFixed(2) : '--'}</span>
  }

  render() {
    const { distributions } = this.state

    if (!distributions) {
      return <p>{NO_DATA_MESSAGE}</p>
    }
    let firstColumnWidth = `${100 / this.columns.length}%`
    return (
      <ScrollingTable
        data={distributions}
        Col1Width={firstColumnWidth}
        columns={this.columns}
        options={this.scrollingTableOptions}
        otherClassName="table-headers--centered"
      />
    )
  }
}

DistributionHistory.propTypes = {
  data: PropTypes.shape({
    distributions: PropTypes.array,
  }),
  presentation: PropTypes.object,
}

export default DistributionHistory
